module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-22-87f65aeb59706d0e7a90a28a8307fc47.png";